// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"b90063f9","297":"b73ad433","643":"b53b6ab6","787":"cda612ba"}[chunkId] + ".chunk.js";
};